import { render, staticRenderFns } from "./SingleStepTeam.vue?vue&type=template&id=3cd88601&scoped=true"
import script from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleStepTeam.vue?vue&type=style&index=0&id=3cd88601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd88601",
  null
  
)

export default component.exports